module.exports = __webpack_public_path__ + "static/img/right_gift.01168f84.png";